import api from "./api.js";

export default class AskApi {
  static async create(data) {
    return await api.post(`api/ask`, data);
  }

  static async getList(data) {
    return await api.get(`api/ask`, data);
  }

  static async getDetail(id, data) {
    return await api.get(`api/ask/${id}`, data);
  }

  static async update(id, data) {
    return await api.patch(`api/ask/${id}`, data);
  }

  static async delete(data) {
    return await api.del(`api/ask`, data);
  }
}
